import { render } from "./KpiCard.vue?vue&type=template&id=c23d9e0e&scoped=true"
import script from "./KpiCard.vue?vue&type=script&lang=js"
export * from "./KpiCard.vue?vue&type=script&lang=js"

import "./KpiCard.vue?vue&type=style&index=0&id=c23d9e0e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23d9e0e"]])

export default __exports__